import { mapStores } from 'pinia'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import useBcSelectedBasketStore from '@/frontapp/store/bcSelectedBasket'
import useBcDocumentStore from '@/frontapp/store/bcDocument'
import useBcFolderStore from '@/frontapp/store/bcFolder'
import { trackEvent } from '../gtm'
import ShareGalleryModal from './ShareGalleryModal'

export default {
  mixins: [ShareGalleryModal],
  computed: {
    showShareBtn () {
      return (this.$route.matched[0].name === 'BCDocument' && this.bcDocumentStore.document.can_download && this.bcDocumentStore.documentRev === null)
          || (this.$route.matched[0].name !== 'BCDocument' && this.bcFolderStore.current?.can_download)
    },
    isActiveShareBtn () {
      return this.bcSelectedStore.list.length > 0
        && this.bcSelectedStore.list.every(e =>
          (e.type === 'folder' && e.hidden === null && e.can_download)
          || (e.type === 'document' && e.hidden === null && e.can_download && e.published__bc_document_rev_id !== null)
          || (e.type !== 'folder' && e.type !== 'document' && this.bcDocumentStore.document?.hidden === null && this.bcDocumentStore.document?.published__bc_document_rev_id !== null)
        )
    },
    ...mapStores(useBcSelectedStore, useBcDocumentStore, useBcFolderStore, useBcSelectedBasketStore),
  },
  methods: {
    clickShareBtn() {
      this.selectAllGalleryModal()
      this.$formValues['frm-sharingForm-sharingForm-sharing_type:change'] = 'email'
      this.$store.commit('nette/updateControl', {
        controlName: 'sharingForm',
        data: true,
        key: 'showModal',
      })
      this.$store.commit('nette/updateControl', {
        controlName: 'sharingForm',
        data: false,
        key: 'basket',
      })
      trackEvent(this.$route.matched[0].name, 'showShareForm')
    },
    clickAddShareBtn() {
      this.bcSelectedBasketStore.addToBasket()
      trackEvent(this.$route.matched[0].name, 'addToShareList')
    }
  },  
}